/**
 * WebSite type
 * DOC: https://schema.org/WebSite
 */

import searchAction from '../structuredData/types/searchAction';
export const siteName = ({
  name,
  url,
  potentialAction
}) => {
  if (!name || !url) {
    throw new Error('name and url arguments are required');
  }
  const result = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    'name': name,
    'url': url,
    ...(potentialAction && {
      potentialAction: searchAction({
        ...potentialAction
      })
    })
  };
  return JSON.stringify(result);
};